import { doGet, doPut, doPost, doDelete } from './common';

const entity = 'authority';

const getList = (user_id) => {
  return doGet(`/api/${entity}/${user_id}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const insert = (user_id, params) => {
  return doPost(`/api/${entity}/${user_id}`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const insertUser = (params) => {
  return doPost(`/api/${entity}/user`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const updateUser = (user_id, params) => {
  return doPut(`/api/${entity}/user/${user_id}`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const deleteUser = (user_id) => {
  return doDelete(`/api/${entity}/user/${user_id}`).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

export {
  getList,
  insertUser,
  updateUser,
  deleteUser
}